import { DotsThreeVertical } from "@phosphor-icons/react";
import { useMemo } from "react";

import CopiableTag from "common/components/CopiableTag";
import DesktopActions from "common/components/DesktopActions";
import SimpleDataTable from "common/components/SimpleDataTable";
import { Button } from "common/components/ui/Button";

import { API_KEYS_ACTIONS } from "../../../constants";
import { formatBillingDate } from "../../../utils";
import ApiKeyActions from "../ApiKeyActions";

import type { ColumnDef } from "@tanstack/react-table";
import type { ApiToken } from "../../../types";

interface DesktopTableProps {
  tokens: ApiToken[];
}

export default function DesktopTable({ tokens }: DesktopTableProps) {
  const columns = useMemo<ColumnDef<ApiToken>[]>(
    () => [
      {
        id: "name",
        header: "Key name",
        meta: { className: "w-64" },
        cell: ({ row }) => (
          <span className="text-sm-bold">{row.original.name}</span>
        ),
      },
      {
        id: "permissions",
        header: "Permissions",
        meta: { className: "w-32" },
        cell: ({ row }) =>
          row.original.write && row.original.read ? "All" : "Read only",
      },
      {
        id: "key",
        header: "Key",
        meta: { className: "w-52" },
        cell: ({ row }) => <CopiableTag value={row.original.token} />,
      },
      {
        id: "createdAt",
        header: "Created at",
        cell: ({ row }) => formatBillingDate(row.original.created_at),
      },
      {
        id: "actions",
        header: "",
        cell: ({ row }) => (
          <DesktopActions
            triggerElement={
              <Button intent="iconOnly" variant="secondary-black" size="sm">
                <DotsThreeVertical />
              </Button>
            }
            editOptions={API_KEYS_ACTIONS}
          >
            {(action, onClose) => (
              <ApiKeyActions
                token={row.original}
                action={action}
                onClose={onClose}
                onBack={onClose}
              />
            )}
          </DesktopActions>
        ),
      },
    ],
    [],
  );

  return (
    <SimpleDataTable
      columns={columns}
      data={tokens}
      localStorageId="api-keys"
    />
  );
}
